import { Dayjs } from 'dayjs';
import { IClassroomEvaluation } from 'interfaces/classrooms';
import { minutesToDays, parseToDayjs } from 'services/date';

export const sanitizeEvaluations = (
  arr: IClassroomEvaluation[] | undefined
): IClassroomEvaluation[] | [] =>
  arr?.filter(obj => obj.kind !== 'replacement') || [];

export const getEvaluationPeriod = (
  requirements: IClassroomEvaluation['requirements']
) => {
  const accessType =
    requirements?.[0]?.rules?.[0]?.kind === 'date' ? 'fixed' : 'relative';

  let dataRange: (Dayjs | string)[] = [];
  let duration: { start_after_days: number; duration_days: number } = {
    start_after_days: 0,
    duration_days: 0
  };

  if (accessType === 'fixed') {
    dataRange = [
      parseToDayjs(
        requirements?.[0]?.rules?.find(rule => rule.operator === 'after')?.value
      ),
      parseToDayjs(
        requirements?.[0]?.rules?.find(rule => rule.operator === 'before')
          ?.value
      )
    ];
  } else if (accessType === 'relative') {
    const startAfterDays = minutesToDays(
      Number(
        requirements?.[0]?.rules?.find(rule => rule.operator === 'after')?.value
      )
    );
    const durationDays = minutesToDays(
      Number(
        requirements?.[0]?.rules?.find(rule => rule.operator === 'before')
          ?.value
      )
    );

    duration = {
      start_after_days: startAfterDays,
      duration_days: durationDays - startAfterDays
    };
  }

  return {
    accessType,
    dateRange: dataRange,
    duration_days: duration?.duration_days,
    start_after_days: duration?.start_after_days
  };
};
